import { z } from 'zod';
import { CursorPagination } from './common.js';
export const ProxySummary = z.object({
    id: z.string().uuid(),
    endpoint: z.string(), // host:port
    /** Auth credentials are never returned to the client. */
    hasAuth: z.boolean(),
    /**
     * How many accounts currently use this proxy. Many-to-one is supported
     * (residential IPs commonly host several low-volume accounts); the count
     * is displayed in admin UI so the operator can pick a less-loaded proxy.
     */
    boundAccountCount: z.number().int().nonnegative(),
    healthStatus: z.enum(['unknown', 'ok', 'degraded', 'failed']),
    lastCheckAt: z.string().datetime().nullable(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
export const CreateProxyRequest = z.object({
    endpoint: z.string().regex(/^[^:\s]+:\d{1,5}$/, 'must be host:port'),
    username: z.string().optional(),
    password: z.string().optional(),
});
export const UpdateProxyRequest = CreateProxyRequest.partial();
export const ListProxiesQuery = CursorPagination.extend({
    healthStatus: z.enum(['unknown', 'ok', 'degraded', 'failed']).optional(),
});
export const BulkImportProxiesRequest = z.object({
    /** Lines of CSV: host:port,username,password (username/password optional). */
    csv: z.string().min(1),
});
export const BulkImportProxiesResponse = z.object({
    created: z.array(ProxySummary),
    failures: z.array(z.object({
        line: z.number().int(),
        content: z.string(),
        reason: z.string(),
    })),
});
export const ProxyHealthCheckResponse = z.object({
    proxyId: z.string().uuid(),
    healthStatus: z.enum(['ok', 'degraded', 'failed']),
    latencyMs: z.number().int().nullable(),
    error: z.string().nullable(),
});
//# sourceMappingURL=proxy.js.map